import { render, staticRenderFns } from "./OriginEnterpriseEdit.vue?vue&type=template&id=4f6cf54e&scoped=true&"
import script from "./OriginEnterpriseEdit.vue?vue&type=script&lang=js&"
export * from "./OriginEnterpriseEdit.vue?vue&type=script&lang=js&"
import style0 from "./OriginEnterpriseEdit.vue?vue&type=style&index=0&id=4f6cf54e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f6cf54e",
  null
  
)

export default component.exports